const mistakes = [
  { icon: "ri-time-line", title: "Waiting for a Routine Processing Timeline", description: "Eastman Chemical employees with standard post office processing face 10–13 week waits during peak season. Corporate international travel can't wait that long. Our expedited service takes 2–9 business days." },
  { icon: "ri-image-line", title: "Wrong Passport Photo Format", description: "Kingsport CVS and Walgreens passport photos sometimes don't meet the exact 2x2 inch, white background specification. We provide a photo verification service before your application is submitted." },
  { icon: "ri-file-list-3-line", title: "Missing Required Documents", description: "First-time Sullivan County applicants often arrive at the post office without an official birth certificate or bring a hospital copy (invalid) instead of a government-issued certificate. We provide a complete checklist." },
  { icon: "ri-user-line", title: "Name Change After Marriage or Divorce", description: "Eastman new hires and recently married Kingsport residents often have name mismatches between their documents. Bring your marriage certificate, court order, or legal name change documentation." },
  { icon: "ri-map-pin-line", title: "Driving to Knoxville Without an Appointment", description: "The Knoxville Passport Agency requires an appointment and is 100+ miles from Kingsport. We handle everything locally — no road trip, no rejection at the door." },
  { icon: "ri-building-4-line", title: "Using Personal Address for Corporate Applications", description: "Eastman employees applying for business travel occasionally use personal information when corporate address or employer documentation is needed for government travel processing. We guide you through the right form." },
];

export default function KingsportMistakesSection() {
  return (
    <section id="mistakes" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Common Mistakes</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Mistakes Kingsport Applicants Make
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Avoid these six common mistakes that cause Kingsport, Sullivan County, and Eastman Chemical employee applications to be rejected or delayed.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mistakes.map((m, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-xl p-7">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-red-100 flex-shrink-0">
                  <i className={`${m.icon} text-red-500 text-xl`}></i>
                </div>
                <div>
                  <h3 className="font-semibold text-[#1A365D] mb-2">{m.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{m.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-[#F6C344] rounded-xl p-8 flex flex-col md:flex-row items-center gap-6">
          <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#1A365D]/10 flex-shrink-0">
            <i className="ri-shield-check-line text-[#1A365D] text-2xl"></i>
          </div>
          <div className="flex-1">
            <h4 className="font-semibold text-[#1A365D] text-lg mb-1">Corporate Document Review Included</h4>
            <p className="text-[#1A365D]/70 text-sm leading-relaxed">
              Every Eastman Chemical and BAE Systems employee application gets a full pre-submission document review. We catch corporate-specific errors before they cause rejections — because your travel schedule doesn't allow for mistakes.
            </p>
          </div>
          <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#1A365D] text-white font-semibold px-6 py-3 rounded-lg hover:bg-[#1A365D]/90 transition-all whitespace-nowrap flex-shrink-0">
            Start Without Mistakes <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}